import { getCookie, getEmailDomain, logo } from "@cash/shared-components";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Card from "./Card";
import Header from "./Header";
import "./index.css";

const Homepage = () => {
  const [config, setConfig] = useState({});
  const username = getCookie("pas");

  const getConfigData = async () => {
    const res = await axios.get("/root/getConfig");
    return res.data;
  };

  useEffect(() => {
    const getData = async () => {
      const data = await getConfigData();
      setConfig(data);
      window.digitalData.push({
        event: "homepageVisit",
        tracking: {
          username,
          agency: getEmailDomain(getCookie("user_email")) || "abbvie",
        }
      });
    };
    getData();
  }, []);

  const cards = [
    {
      id: 1,
      title: "ATSoMATIC",
      subTitle: "FOR INTERNAL USE",
      content: "Website Analytics Tag Authoring",
      isEditable: true,
      className: "card-skyblue",
      navigateTo: config.ATSOMATIC_LINK,
    },
    {
      id: 2,
      title: "Screenshot Pro",
      content:
        "Webpage(s) layout automated PDF for Medical, Legal and Regulatory review",
      isEditable: true,
      className: "card-skyblue",
      navigateTo: "/mlr",
    },
    {
      id: 3,
      title: "Link Pro",
      subTitle: "In Pilot Testing",
      content: "Interactive linked URL's Report",
      isEditable: true,
      className: "card-skyblue",
      navigateTo: "/ilur",
    },
    {
      id: 4,
      title: "Preview Pro",
      content: "Review all changes across web properties",
      isEditable: true,
      className: "card-skyblue",
      navigateTo: config.SITEMATRIX_LINK,
    },
    {
      id: 5,
      title: "Sitemap Pro",
      subTitle: "In Pilot Testing",
      content: "Create a Sitemap for your MRP submission",
      isEditable: true,
      className: "card-skyblue",
      navigateTo: "/sitemap",
    },
    {
      id: 6,
      title: "Tag Pro",
      content:
        "Generate all required OG and Metadata for your MRP submission",
      isEditable: true,
      className: "card-skyblue",
      navigateTo: "/ogmi",
      backgroundImage: "/images/mlr-background.jpg",
    },
  ];

  const handleCardClick = (navigateTo, title) => {
    window.digitalData.push({
      event: "toolClick",
      tracking: {
        toolName: title,
        username,
        agency: getEmailDomain(getCookie("user_email")) || "abbvie",
      }
    });
    window.location.href = navigateTo;
  };

  return (
    <div className="dashboard-wrapper">
      <Header
        showLogo={true}
        showHome={false}
        title={
          <div className="sub-logo" style={{ alignItems: "center" }}>
            <h6 className="dashboard-title"></h6>
            <span style={{ fontSize: "25px" }}>
              <span className="logo">
                Content Automation Solutions Hub (CASH)
              </span>
            </span>
          </div>
        }
      />
      <div className="card-container" style={{ fontSize: "15px" }}>
        {cards.sort((a, b) => a.title.localeCompare(b.title)).map(
          ({ id, className, title, isEditable, content, navigateTo, subTitle }) => (
            <Card
              key={id}
              className={className}
              title={title}
              isEditable={isEditable}
              subTitle={subTitle}
              onClick={() => handleCardClick(navigateTo, title)}
              content={<div className="content">{content}</div>}
            />
          )
        )}
      </div>
      {/* Footer */}
      <footer className="dashboard-footer">
        <nav>
          <ul
            style={{
              display: "flex",
              listStyleType: "none",
              padding: 0,
              margin: 0,
            }}
          >
            <li style={{ marginRight: "20px" }}>
              <a href="/home" style={{ color: "inherit", textDecoration: "none" }}>
                Content Automation Solutions Hub (CASH)
              </a>
            </li>
          </ul>
        </nav>
        <img src={logo} alt="Company Logo" className="footer-logo" />
      </footer>
    </div>
  );
};

export default Homepage;
